import React from 'react'

import PerformanceOptions from '../PerformanceOptions.jsx'

export default function ExchangeTradedFundsPerformanceOptions({
  selectedPerformanceFrequency,
  selectedDisplayBenchmark,
  selectedDisplayMorningstar,
  onChangePerformanceType,
  onChangePerformanceFrequency,
  onChangeDisplayBenchmark,
  onChangeDisplayMorningstar,
}) {
  const renderPerformanceTypeOptions = () => {
    return (
      <>
        <option value="nav">NAV</option>
        <option value="atmarket">At Market</option>
      </>
    )
  }

  return (
    <PerformanceOptions
      performanceTypeOptions={renderPerformanceTypeOptions}
      primaryBenchmarkName="Tracked Index"
      selectedPerformanceFrequency={selectedPerformanceFrequency}
      selectedDisplayBenchmark={selectedDisplayBenchmark}
      selectedDisplayMorningstar={selectedDisplayMorningstar}
      onChangePerformanceType={onChangePerformanceType}
      onChangePerformanceFrequency={onChangePerformanceFrequency}
      onChangeDisplayBenchmark={onChangeDisplayBenchmark}
      onChangeDisplayMorningstar={onChangeDisplayMorningstar}
    />
  )
}
